import React, {useContext, useState, useEffect} from 'react';
import {BarCodeScannerContext} from "../../../../../../../contexts/barCodeScannerContext";
import PropTypes from 'prop-types';

import CustomButton from "../../../../../../../components/CustomButton";
import Popup from "../../../../../../../components/WMS/Mobile/Popup";
import {FormattedMessage} from "react-intl";
import {ReactComponent as ErrorIcon} from "assets/img/picto-error-404.svg"
import {ReactComponent as InventoryIcon} from 'assets/img/wms/inventoryIcon.svg'
import {WMSContext} from "../../../../../context/WMSContext";
import {getWMSContainersWithType, sortingMassTransfer} from "../../../../../../../api/wms/wmsContainers/wmsContainers";
import {WmsContainerType} from "../../../../../../../utils/WMSContainerType";
import BeatLoaderRegular from "../../../../../../../components/loaders/BeatLoaderRegular";
import {Grid} from "@mui/material";

StackTransfer.propTypes = {
    currentContainer: PropTypes.object.isRequired,
    handleIsValid: PropTypes.func.isRequired,
    fullWidth: PropTypes.bool.isRequired,
    onPopupOpenChange: PropTypes.func,
}

function StackTransfer({currentContainer, handleIsValid, fullWidth, onPopupOpenChange}) {
    const {currentInventory} = useContext(WMSContext)
    const {withScanDisabled} = useContext(BarCodeScannerContext)

    const [openStackTransferModal, setOpenStackTransferModal] = useState(false)
    const [openStackTransferErrorModal, setOpenStackTransferErrorModal] = useState(false)
    const [stackContainer, setStackContainer] = useState()
    const [errors, setErrors] = useState()
    const [loading, setLoading] = useState(true)

    if (WmsContainerType.TROLLEY !== currentContainer.type) {
        return
    }

    function handleCloseStackTransferModal(isTransferValid = false) {
        setOpenStackTransferModal(false)
        onPopupOpenChange?.(false)
        if (isTransferValid) {
            handleIsValid(true)
        }
    }

    function handleCloseStackTransferErrorModal() {
        setOpenStackTransferErrorModal(false)
    }

    async function handleValidateStackTransfert() {
        await withScanDisabled(async () => {
            const response = await sortingMassTransfer(currentContainer.codebar, stackContainer.codebar, currentInventory.id)
            if (0 < Object.keys(response).length) {
                setErrors(response)
                handleCloseStackTransferModal()
                setOpenStackTransferErrorModal(true)
            } else {
                handleCloseStackTransferModal(true)
            }
        })
    }

    const getFormattedKey = (key) => {
        switch (key) {
            case "not-found":
                return <FormattedMessage id={"wms.sorting.TransferErrorModal.notFoundKey"}/>
            case "wrongInventory":
                return <FormattedMessage id={"wms.sorting.TransferErrorModal.wrongInventoryKey"}/>
            case "wrongType":
                return <FormattedMessage id={"wms.sorting.TransferErrorModal.wrongTypeKey"}/>
            default:
                return <FormattedMessage id={"list.error"}/>
        }
    }

    const getErrorModalSubtitle = () => {
        const errorKeys = Object.keys(errors)
        return (
            <>
                {errorKeys.map(key => {
                    return <Grid key={key} container direction={"column"}>
                        {getFormattedKey(key)}
                        {errors[key].map(shipment => {
                            return <span key={shipment}>{shipment}</span>
                        })}
                    </Grid>
                })}
            </>
        )
    }

    useEffect(() => {
        if (currentInventory) {
            getWMSContainersWithType(WmsContainerType.STACK, currentInventory.id).then((response) => {
                setStackContainer(response[0])
            }).finally(() => {
                setLoading(false)
            })
        }
    }, [currentInventory]);


    if (!currentContainer) {
        return null
    }

    return (
        <>
            {openStackTransferModal && (
                <Popup
                    open={openStackTransferModal}
                    onClose={handleCloseStackTransferModal}
                    title={<FormattedMessage id={'wms.sorting.stackTransferModal.title'}/>}
                    subtitle={<FormattedMessage id={'wms.sorting.stackTransferModal.subtitle'}/>}
                    icon={<InventoryIcon/>}
                    isMobile
                >
                    <Grid container justifyContent={'center'}>
                        {!loading && (
                            <CustomButton
                                onClick={handleValidateStackTransfert}
                                fullWidth
                                disabled={!stackContainer}
                            >
                                <div style={{textWrap: "wrap"}}>
                                    <FormattedMessage id={'wms.sorting.stackTransferModal.validButton.label'}/>
                                </div>
                            </CustomButton>
                        )}

                        {loading && (
                            <BeatLoaderRegular loading={loading}/>
                        )}
                    </Grid>
                </Popup>
            )}

            {openStackTransferErrorModal && (
                <Popup
                    open={openStackTransferErrorModal}
                    onClose={handleCloseStackTransferErrorModal}
                    title={<FormattedMessage id={"wms.sorting.TransferErrorModal.title"}/>}
                    subtitle={getErrorModalSubtitle()}
                    icon={<ErrorIcon/>}
                    isMobile
                />
            )}

            <CustomButton
                onClick={() => { setOpenStackTransferModal(true); onPopupOpenChange?.(true) }}
                style={{
                    marginLeft: '8px',
                    cursor: 'pointer'
                }}
                color={"lightOrange"}
                fullWidth={fullWidth}
            >
                <FormattedMessage id={'wms.sorting.stackTransferModal.buttonLabel'} />
            </CustomButton>
        </>
    );
}

export default StackTransfer;